<div class="max-w-360 mx-auto px-4">
  <div class="mt-4">
    <!-- Przycisk wstecz (mobilka: osobny wiersz) -->
    <button mat-icon-button (click)="goBack()" matTooltip="Wróć do listy dokumentów" class="-ml-2 mb-2 md:hidden">
      <mat-icon [svgIcon]="'tabler_outline:arrow-left'"></mat-icon>
    </button>

    <div class="flex items-start gap-3">
      <!-- Przycisk wstecz (tablet+: inline, wycentrowany względem tekstów) -->
      <button mat-icon-button (click)="goBack()" matTooltip="Wróć do listy dokumentów"
        class="hidden md:flex flex-shrink-0 -ml-2 mt-3">
        <mat-icon [svgIcon]="'tabler_outline:arrow-left'"></mat-icon>
      </button>

      <div class="flex-1 min-w-0">
        <div class="text-lg">Podgląd</div>
        <div class="md:flex md:items-center md:gap-4">
          <h3 class="text-3xl font-medium flex-shrink-0">{{ isKsefDocument ? document?.documentNumber :
            invoice?.invoiceName }}</h3>
          <div class="flex items-center space-x-2 mt-1 md:mt-1 flex-wrap">
            <!-- Badge kierunku dla faktur z KSeF -->
            <div *ngIf="isKsefDocument"
              [matTooltip]="document?.direction === 'income' ? 'Przychód (wystawiona)' : 'Koszt (otrzymana)'"
              class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border" [ngClass]="document?.direction === 'income' 
          ? 'bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 border-emerald-200 dark:border-emerald-800' 
          : 'bg-rose-50 dark:bg-rose-900/20 text-rose-600 dark:text-rose-400 border-rose-200 dark:border-rose-800'">
              <mat-icon class="!w-3.5 !h-3.5"
                [svgIcon]="document?.direction === 'income' ? 'tabler_outline:arrow-up-right' : 'tabler_outline:arrow-down-left'"
                [ngClass]="document?.direction === 'income' ? 'text-emerald-600 dark:text-emerald-400' : 'text-rose-600 dark:text-rose-400'"></mat-icon>
              {{ document?.direction === 'income' ? 'Przychód' : 'Koszt' }}
            </div>
            <!-- Badge dla faktury zaliczkowej z KSeF -->
            <div *ngIf="isKsefAdvanceInvoice" matTooltip="Faktura zaliczkowa"
              class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 border border-purple-200 dark:border-purple-800">
              <mat-icon class="!w-3.5 !h-3.5 text-purple-600 dark:text-purple-400"
                [svgIcon]="'tabler_outline:receipt-2'"></mat-icon>
              Zaliczka
            </div>
            <!-- Badge dla zamówień/ofert (lokalne) -->
            <div *ngIf="!isKsefDocument && isOrderDocument" matTooltip="Zamówienie"
              class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 border border-purple-200 dark:border-purple-800">
              <mat-icon class="!w-3.5 !h-3.5 text-purple-600 dark:text-purple-400"
                [svgIcon]="'tabler_outline:clipboard-list'"></mat-icon>
              Zamówienie
            </div>
            <div *ngIf="!isKsefDocument && !isOrderDocument && document?.isPaid"
              class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary border border-primary/20">
              <mat-icon class="!w-3.5 !h-3.5 text-primary" [svgIcon]="'tabler_outline:file-check'"></mat-icon>
              Wystawiono
            </div>
            <div *ngIf="!isKsefDocument && !isOrderDocument && !document?.isPaid"
              class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-gray-600">
              <mat-icon class="!w-3.5 !h-3.5 text-gray-500 dark:text-gray-400"
                [svgIcon]="'tabler_outline:pencil'"></mat-icon>
              Szkic
            </div>
            <div *ngIf="document?.isSent" matTooltip="Wysłano do klienta"
              class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-sky-50 dark:bg-sky-900/20 text-sky-600 dark:text-sky-400 border border-sky-200 dark:border-sky-800">
              <mat-icon class="!w-3.5 !h-3.5 text-sky-600 dark:text-sky-400"
                [svgIcon]="'tabler_outline:mail-check'"></mat-icon>
              Wysłano
            </div>
            <div *ngIf="document?.isDownloaded" matTooltip="Dokument został pobrany"
              class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600 dark:text-indigo-400 border border-indigo-200 dark:border-indigo-800">
              <mat-icon class="!w-3.5 !h-3.5 text-indigo-600 dark:text-indigo-400"
                [svgIcon]="'tabler_outline:download'"></mat-icon>
              Pobrano
            </div>
            <div *ngIf="document?.isPrinted" matTooltip="Dokument został wydrukowany"
              class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-violet-50 dark:bg-violet-900/20 text-violet-600 dark:text-violet-400 border border-violet-200 dark:border-violet-800">
              <mat-icon class="!w-3.5 !h-3.5 text-violet-600 dark:text-violet-400"
                [svgIcon]="'tabler_outline:printer'"></mat-icon>
              Wydrukowano
            </div>
            <div *ngIf="isPaymentReceived" matTooltip="Faktura została opłacona"
              class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-800">
              <mat-icon class="!w-3.5 !h-3.5 text-emerald-600 dark:text-emerald-400"
                [svgIcon]="'tabler_outline:circle-check'"></mat-icon>
              Zapłacono
            </div>
            <div *ngIf="ksefStatus === 'pending'" matTooltip="Wysłano do KSeF – oczekuje na potwierdzenie"
              class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 border border-amber-200 dark:border-amber-800">
              <mat-icon class="!w-3.5 !h-3.5 text-amber-600 dark:text-amber-400 animate-pulse"
                [svgIcon]="'tabler_outline:clock-hour-3'"></mat-icon>
              Przetwarzanie KSeF
            </div>
            <div *ngIf="ksefStatus === 'success' && document?.direction !== 'expense' && !isKsefDocument"
              [matTooltip]="document?.ksefSentAt ? ('Wysłano do KSeF ' + (document!.ksefSentAt | date : 'dd.MM.yyyy HH:mm')) : 'Wysłano do KSeF'"
              class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 dark:bg-green-900/20 text-green-600 dark:text-green-400 border border-green-200 dark:border-green-800">
              <mat-icon class="!w-3.5 !h-3.5" [svgIcon]="'ksef:ksef-logo'"></mat-icon>
            </div>
          </div><!-- /badges -->
        </div><!-- /md:flex -->
      </div><!-- /flex-1 -->
    </div><!-- /items-start -->
  </div>
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 my-4">
    <div class="w-full sm:col-span-2">

      <!-- === PODGLĄD DLA FAKTUR Z KSeF (HTML) === -->
      <ng-container *ngIf="isKsefDocument">
        <div class="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6">
          <div class="flex items-center gap-3 mb-6 pb-4 border-b border-gray-200 dark:border-gray-700">
            <mat-icon class="!w-8 !h-8" [svgIcon]="'ksef:ksef-logo'"></mat-icon>
            <div>
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">{{ document?.documentNumber }}</h3>
              <p class="text-sm text-gray-500">{{ document?.documentType | documentTypeName }}</p>
            </div>
          </div>

          <!-- Dane podstawowe -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div>
              <h4 class="text-sm font-semibold text-gray-500 dark:text-gray-400 mb-2">DANE FAKTURY</h4>
              <div class="space-y-2">
                <div class="flex justify-between">
                  <span class="text-gray-600 dark:text-gray-400">Numer faktury:</span>
                  <span class="font-medium text-gray-900 dark:text-white">{{ document?.documentNumber }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="text-gray-600 dark:text-gray-400">Data wystawienia:</span>
                  <span class="font-medium text-gray-900 dark:text-white">
                    <date-formatter [date]="document?.issueDate"></date-formatter>
                  </span>
                </div>
                <div *ngIf="ksefPeriodInfo">
                  <div class="text-gray-600 dark:text-gray-400 text-sm mb-1">Data dokonania lub zakończenia dostawy
                    towarów lub wykonania usługi:</div>
                  <div class="font-medium text-gray-900 dark:text-white">
                    <ng-container *ngIf="ksefPeriodInfo.dateFrom && ksefPeriodInfo.dateTo">
                      od <date-formatter [date]="ksefPeriodInfo.dateFrom"></date-formatter> do <date-formatter
                        [date]="ksefPeriodInfo.dateTo"></date-formatter>
                    </ng-container>
                    <ng-container *ngIf="ksefPeriodInfo.dateFrom && !ksefPeriodInfo.dateTo">
                      od <date-formatter [date]="ksefPeriodInfo.dateFrom"></date-formatter>
                    </ng-container>
                    <ng-container *ngIf="!ksefPeriodInfo.dateFrom && ksefPeriodInfo.dateTo">
                      do <date-formatter [date]="ksefPeriodInfo.dateTo"></date-formatter>
                    </ng-container>
                  </div>
                </div>
                <div class="flex justify-between">
                  <span class="text-gray-600 dark:text-gray-400">Typ dokumentu:</span>
                  <span class="font-medium text-gray-900 dark:text-white">{{ document?.documentType | documentTypeName
                    }}</span>
                </div>
                <div *ngIf="ksefSystemInfo" class="flex justify-between">
                  <span class="text-gray-600 dark:text-gray-400">System źródłowy:</span>
                  <span class="font-medium text-gray-900 dark:text-white">{{ ksefSystemInfo }}</span>
                </div>
              </div>
            </div>

            <div>
              <h4 class="text-sm font-semibold text-gray-500 dark:text-gray-400 mb-2">KWOTY</h4>
              <div class="space-y-2">
                <div class="flex justify-between">
                  <span class="text-gray-600 dark:text-gray-400">Kwota brutto:</span>
                  <span class="font-bold text-xl text-gray-900 dark:text-white">
                    {{ document?.grossSum | number:'1.2-2' }} {{ document?.currency || 'PLN' }}
                  </span>
                </div>
                <div class="flex justify-between" *ngIf="ksefRawData?.netAmount">
                  <span class="text-gray-600 dark:text-gray-400">Kwota netto:</span>
                  <span class="font-medium text-gray-900 dark:text-white">
                    {{ ksefRawData?.netAmount | number:'1.2-2' }} {{ document?.currency || 'PLN' }}
                  </span>
                </div>
                <div class="flex justify-between" *ngIf="ksefRawData?.vatAmount">
                  <span class="text-gray-600 dark:text-gray-400">VAT:</span>
                  <span class="font-medium text-gray-900 dark:text-white">
                    {{ ksefRawData?.vatAmount | number:'1.2-2' }} {{ (document?.currency && document?.currency !==
                    'PLN') ? 'PLN' : (document?.currency || 'PLN') }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Sprzedawca i Nabywca -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div class="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4">
              <h4 class="text-sm font-semibold text-gray-500 dark:text-gray-400 mb-3">SPRZEDAWCA</h4>
              <div class="space-y-1">
                <div class="font-medium text-gray-900 dark:text-white">{{ ksefRawData?.seller?.name ||
                  document?.seller?.name }}</div>
                <div class="text-sm text-gray-600 dark:text-gray-400">
                  {{ getSellerIdentifier().prefix }}: {{ getSellerIdentifier().value }}
                </div>
                <ng-container *ngIf="ksefSellerInfo">
                  <div *ngIf="ksefSellerInfo.addressLine1" class="text-sm text-gray-600 dark:text-gray-400">
                    {{ ksefSellerInfo.addressLine1 }}
                  </div>
                  <div *ngIf="ksefSellerInfo.addressLine2" class="text-sm text-gray-600 dark:text-gray-400">
                    {{ ksefSellerInfo.addressLine2 }}
                  </div>
                  <div *ngIf="ksefSellerInfo.countryCode && ksefSellerInfo.countryCode !== 'PL'"
                    class="text-sm text-gray-600 dark:text-gray-400">
                    Kraj: {{ ksefSellerInfo.countryCode }}
                  </div>
                  <div *ngIf="ksefSellerInfo.email"
                    class="text-sm text-gray-600 dark:text-gray-400 flex items-center gap-1 mt-1">
                    <mat-icon class="!w-3.5 !h-3.5 text-gray-400" [svgIcon]="'tabler_outline:mail'"></mat-icon>
                    <a [href]="'mailto:' + ksefSellerInfo.email" class="text-primary hover:underline">{{
                      ksefSellerInfo.email }}</a>
                  </div>
                  <div *ngIf="ksefSellerInfo.phone"
                    class="text-sm text-gray-600 dark:text-gray-400 flex items-center gap-1">
                    <mat-icon class="!w-3.5 !h-3.5 text-gray-400" [svgIcon]="'tabler_outline:phone'"></mat-icon>
                    <a [href]="'tel:' + ksefSellerInfo.phone" class="text-primary hover:underline">{{
                      ksefSellerInfo.phone }}</a>
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4">
              <h4 class="text-sm font-semibold text-gray-500 dark:text-gray-400 mb-3">NABYWCA</h4>
              <div class="space-y-1">
                <div class="font-medium text-gray-900 dark:text-white">{{ ksefRawData?.buyer?.name ||
                  document?.buyer?.name }}</div>
                <div class="text-sm text-gray-600 dark:text-gray-400">
                  {{ getBuyerIdentifier().prefix }}{{ getBuyerIdentifier().value ? ': ' + getBuyerIdentifier().value :
                  '' }}
                </div>
                <ng-container *ngIf="ksefBuyerInfo">
                  <div *ngIf="ksefBuyerInfo.addressLine1" class="text-sm text-gray-600 dark:text-gray-400">
                    {{ ksefBuyerInfo.addressLine1 }}
                  </div>
                  <div *ngIf="ksefBuyerInfo.addressLine2" class="text-sm text-gray-600 dark:text-gray-400">
                    {{ ksefBuyerInfo.addressLine2 }}
                  </div>
                  <div *ngIf="ksefBuyerInfo.countryCode && ksefBuyerInfo.countryCode !== 'PL'"
                    class="text-sm text-gray-600 dark:text-gray-400">
                    Kraj: {{ ksefBuyerInfo.countryCode }}
                  </div>
                  <div *ngIf="ksefBuyerInfo.email"
                    class="text-sm text-gray-600 dark:text-gray-400 flex items-center gap-1 mt-1">
                    <mat-icon class="!w-3.5 !h-3.5 text-gray-400" [svgIcon]="'tabler_outline:mail'"></mat-icon>
                    <a [href]="'mailto:' + ksefBuyerInfo.email" class="text-primary hover:underline">{{
                      ksefBuyerInfo.email }}</a>
                  </div>
                  <div *ngIf="ksefBuyerInfo.phone"
                    class="text-sm text-gray-600 dark:text-gray-400 flex items-center gap-1">
                    <mat-icon class="!w-3.5 !h-3.5 text-gray-400" [svgIcon]="'tabler_outline:phone'"></mat-icon>
                    <a [href]="'tel:' + ksefBuyerInfo.phone" class="text-primary hover:underline">{{ ksefBuyerInfo.phone
                      }}</a>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>

          <!-- Informacje o korekcie (jeśli to faktura korygująca) -->
          <div *ngIf="ksefCorrectionInfo" class="mb-6">
            <h4 class="text-sm font-semibold text-gray-500 dark:text-gray-400 mb-3">DANE KOREKTY</h4>

            <div class="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4">
              <!-- Nagłówek z typem -->
              <div class="flex items-center gap-2 mb-4">
                <div class="flex items-center justify-center w-10 h-10 rounded-full bg-amber-100 dark:bg-amber-800/50">
                  <mat-icon class="!w-5 !h-5 text-amber-600 dark:text-amber-400"
                    [svgIcon]="'tabler_outline:file-diff'"></mat-icon>
                </div>
                <div>
                  <div class="font-semibold text-amber-800 dark:text-amber-200">Faktura korygująca</div>
                  <div class="text-xs text-amber-600 dark:text-amber-400">{{ ksefCorrectionInfo.correctionTypeName }}
                  </div>
                </div>
              </div>

              <!-- Grid z danymi -->
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <!-- Faktura korygowana -->
                <div class="bg-white/60 dark:bg-gray-800/40 rounded-lg p-3">
                  <div class="text-xs font-medium text-amber-600 dark:text-amber-400 uppercase mb-1">Korygowana faktura
                  </div>
                  <div class="font-semibold text-gray-900 dark:text-white">
                    {{ ksefCorrectionInfo.correctedInvoiceNumber || '-' }}
                  </div>
                  <div *ngIf="ksefCorrectionInfo.correctedInvoiceDate"
                    class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                    z dnia {{ formatDateHuman(ksefCorrectionInfo.correctedInvoiceDate) }}
                  </div>
                </div>

                <!-- Nr KSeF faktury korygowanej (jeśli jest) -->
                <div *ngIf="ksefCorrectionInfo.correctedKsefNumber"
                  class="bg-white/60 dark:bg-gray-800/40 rounded-lg p-3">
                  <div class="text-xs font-medium text-amber-600 dark:text-amber-400 uppercase mb-1">Nr KSeF korygowanej
                  </div>
                  <div class="font-mono text-sm text-gray-900 dark:text-white break-all">
                    {{ ksefCorrectionInfo.correctedKsefNumber }}
                  </div>
                </div>

                <!-- Typ korekty -->
                <div class="bg-white/60 dark:bg-gray-800/40 rounded-lg p-3">
                  <div class="text-xs font-medium text-amber-600 dark:text-amber-400 uppercase mb-1">Typ korekty</div>
                  <div class="flex items-center gap-2">
                    <span class="inline-flex items-center justify-center w-6 h-6 rounded-full text-xs font-bold"
                      [ngClass]="{
                        'bg-blue-100 text-blue-700 dark:bg-blue-800/50 dark:text-blue-300': ksefCorrectionInfo.correctionType === 1,
                        'bg-green-100 text-green-700 dark:bg-green-800/50 dark:text-green-300': ksefCorrectionInfo.correctionType === 2,
                        'bg-purple-100 text-purple-700 dark:bg-purple-800/50 dark:text-purple-300': ksefCorrectionInfo.correctionType === 3,
                        'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300': !ksefCorrectionInfo.correctionType
                      }">
                      {{ ksefCorrectionInfo.correctionType || '?' }}
                    </span>
                    <span class="text-sm text-gray-700 dark:text-gray-300">{{ ksefCorrectionInfo.correctionTypeName
                      }}</span>
                  </div>
                </div>
              </div>

              <!-- Przyczyna korekty -->
              <div *ngIf="ksefCorrectionInfo.correctionReason"
                class="mt-4 bg-white/60 dark:bg-gray-800/40 rounded-lg p-3">
                <div class="text-xs font-medium text-amber-600 dark:text-amber-400 uppercase mb-1">Przyczyna korekty
                </div>
                <div class="text-sm text-gray-800 dark:text-gray-200 leading-relaxed">
                  {{ ksefCorrectionInfo.correctionReason }}
                </div>
              </div>
            </div>
          </div>

          <!-- Informacje o zaliczce (jeśli to faktura zaliczkowa ZAL) -->
          <div *ngIf="isKsefAdvanceInvoice" class="mb-6">
            <div
              class="bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-lg p-4">
              <div class="flex items-center gap-2 mb-3">
                <div class="flex items-center justify-center w-8 h-8 rounded-full bg-purple-100 dark:bg-purple-800/50">
                  <mat-icon class="!w-4 !h-4 text-purple-600 dark:text-purple-400"
                    [svgIcon]="'tabler_outline:receipt-2'"></mat-icon>
                </div>
                <div class="font-semibold text-purple-800 dark:text-purple-200">Faktura zaliczkowa</div>
              </div>

              <!-- Kwoty zaliczki -->
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                <div class="bg-white/60 dark:bg-gray-800/40 rounded-lg p-3">
                  <div class="text-xs font-medium text-purple-600 dark:text-purple-400 uppercase mb-1">Kwota netto
                    zaliczki</div>
                  <div class="font-bold text-lg text-gray-900 dark:text-white">
                    {{ ksefRawData?.netAmount | number:'1.2-2' }} {{ document?.currency || 'PLN' }}
                  </div>
                </div>
                <div class="bg-white/60 dark:bg-gray-800/40 rounded-lg p-3">
                  <div class="text-xs font-medium text-purple-600 dark:text-purple-400 uppercase mb-1">VAT zaliczki
                  </div>
                  <div class="font-bold text-lg text-gray-900 dark:text-white">
                    {{ ksefRawData?.vatAmount | number:'1.2-2' }} {{ (document?.currency && document?.currency !==
                    'PLN') ? 'PLN' : (document?.currency || 'PLN') }}
                  </div>
                </div>
                <div class="bg-white/60 dark:bg-gray-800/40 rounded-lg p-3">
                  <div class="text-xs font-medium text-purple-600 dark:text-purple-400 uppercase mb-1">Kwota brutto
                    zaliczki</div>
                  <div class="font-bold text-lg text-gray-900 dark:text-white">
                    {{ document?.grossSum | number:'1.2-2' }} {{ document?.currency || 'PLN' }}
                  </div>
                </div>
              </div>

              <!-- Wartość całego zamówienia -->
              <div *ngIf="ksefOrderInfo" class="bg-white/60 dark:bg-gray-800/40 rounded-lg p-3 mb-4">
                <div class="flex items-center justify-between">
                  <div class="text-xs font-medium text-purple-600 dark:text-purple-400 uppercase">Wartość całego
                    zamówienia</div>
                  <div class="font-bold text-xl text-purple-700 dark:text-purple-300">
                    {{ ksefOrderInfo.orderValue | number:'1.2-2' }} {{ document?.currency || 'PLN' }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Informacje o korekcie faktury zaliczkowej (KOR_ZAL) -->
          <div *ngIf="isKsefAdvanceCorrectionInvoice" class="mb-6">
            <div class="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4">
              <div class="flex items-center gap-2 mb-3">
                <div class="flex items-center justify-center w-8 h-8 rounded-full bg-amber-100 dark:bg-amber-800/50">
                  <mat-icon class="!w-4 !h-4 text-amber-600 dark:text-amber-400"
                    [svgIcon]="'tabler_outline:receipt-refund'"></mat-icon>
                </div>
                <div class="font-semibold text-amber-800 dark:text-amber-200">Korekta faktury zaliczkowej</div>
              </div>

              <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
                <!-- Kwota brutto korygowanej faktury (P_15ZK) -->
                <div *ngIf="ksefOrderInfo?.grossAmountBeforeCorrection"
                  class="bg-white/60 dark:bg-gray-800/40 rounded-lg p-3">
                  <div class="text-xs font-medium text-amber-600 dark:text-amber-400 uppercase mb-1">Brutto korygowanej
                    faktury (PLN)</div>
                  <div class="font-bold text-lg text-gray-900 dark:text-white">
                    {{ ksefOrderInfo?.grossAmountBeforeCorrection | number:'1.2-2' }} PLN
                  </div>
                </div>
                <!-- Kurs waluty korygowanej (KursWalutyZK) -->
                <div *ngIf="ksefOrderInfo?.exchangeRateBeforeCorrection"
                  class="bg-white/60 dark:bg-gray-800/40 rounded-lg p-3">
                  <div class="text-xs font-medium text-amber-600 dark:text-amber-400 uppercase mb-1">Kurs waluty (przed
                    korektą)</div>
                  <div class="font-bold text-lg text-gray-900 dark:text-white">
                    {{ ksefOrderInfo?.exchangeRateBeforeCorrection | number:'1.2-4' }}
                  </div>
                </div>
                <!-- Kurs waluty po korekcie (KursWalutyZ) -->
                <div *ngIf="ksefOrderInfo?.exchangeRate" class="bg-white/60 dark:bg-gray-800/40 rounded-lg p-3">
                  <div class="text-xs font-medium text-amber-600 dark:text-amber-400 uppercase mb-1">Kurs waluty (po
                    korekcie)</div>
                  <div class="font-bold text-lg text-gray-900 dark:text-white">
                    {{ ksefOrderInfo?.exchangeRate | number:'1.2-4' }}
                  </div>
                </div>
              </div>

              <!-- Wartość całego zamówienia po korekcie -->
              <div *ngIf="ksefOrderInfo" class="bg-white/60 dark:bg-gray-800/40 rounded-lg p-3">
                <div class="flex items-center justify-between">
                  <div class="text-xs font-medium text-amber-600 dark:text-amber-400 uppercase">Wartość zamówienia (po
                    korekcie)</div>
                  <div class="font-bold text-xl text-amber-700 dark:text-amber-300">
                    {{ ksefOrderInfo.orderValue | number:'1.2-2' }} {{ document?.currency || 'PLN' }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Pozycje zamówienia z KSeF XML (dla faktur zaliczkowych) -->
          <div *ngIf="isKsefAdvanceInvoice && ksefOrderInfo && ksefOrderInfo.items.length > 0" class="mb-6">
            <h4 class="text-sm font-semibold text-gray-500 dark:text-gray-400 mb-3">POZYCJE ZAMÓWIENIA</h4>

            <div class="overflow-x-auto">
              <table class="w-full text-sm">
                <thead>
                  <tr class="border-b border-gray-200 dark:border-gray-700">
                    <th class="text-left py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Lp.</th>
                    <th class="text-left py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Nazwa</th>
                    <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Ilość</th>
                    <th class="text-center py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">J.m.</th>
                    <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Cena netto</th>
                    <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Netto</th>
                    <th class="text-center py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">VAT</th>
                    <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Brutto</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of ksefOrderInfo.items; let i = index"
                    class="border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700/30">
                    <td class="py-2 px-2 text-gray-500 dark:text-gray-400">{{ item.lp }}</td>
                    <td class="py-2 px-2 text-gray-900 dark:text-white">{{ item.name }}</td>
                    <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.quantity | number:'1.0-4'
                      }}</td>
                    <td class="py-2 px-2 text-center text-gray-500 dark:text-gray-400">{{ item.unit }}</td>
                    <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.unitNetPrice |
                      number:'1.2-2' }}</td>
                    <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.netValue | number:'1.2-2'
                      }}</td>
                    <td class="py-2 px-2 text-center text-gray-500 dark:text-gray-400">{{ formatVatRate(item.vatRate) }}
                    </td>
                    <td class="py-2 px-2 text-right font-medium text-gray-900 dark:text-white">{{ item.grossValue |
                      number:'1.2-2' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Pozycje zamówienia z KSeF XML (dla korekt faktur zaliczkowych KOR_ZAL - przed/po korekcie) -->
          <div *ngIf="isKsefAdvanceCorrectionInvoice" class="mb-6">

            <!-- Ładowanie -->
            <div *ngIf="isLoadingKsefXml"
              class="flex items-center justify-center py-8 text-gray-500 dark:text-gray-400">
              <mat-spinner diameter="24" class="mr-3"></mat-spinner>
              <span>Pobieranie danych z KSeF...</span>
            </div>

            <ng-container *ngIf="!isLoadingKsefXml && ksefOrderInfo && ksefOrderInfo.items.length > 0">

              <!-- Zamówienie z podziałem na przed/po korekcie -->
              <ng-container *ngIf="hasOrderCorrectionBeforeAfterItems">

                <!-- Zamówienie PRZED korektą -->
                <div class="mb-6">
                  <div class="flex items-center gap-2 mb-3">
                    <div class="flex items-center justify-center w-6 h-6 rounded-full bg-red-100 dark:bg-red-900/40">
                      <mat-icon class="!w-3.5 !h-3.5 text-red-600 dark:text-red-400"
                        [svgIcon]="'tabler_outline:arrow-back'"></mat-icon>
                    </div>
                    <h4 class="text-sm font-semibold text-red-600 dark:text-red-400">ZAMÓWIENIE PRZED KOREKTĄ</h4>
                    <span *ngIf="ksefOrderInfo.exchangeRateBeforeCorrection"
                      class="text-xs text-gray-500 dark:text-gray-400 ml-2">
                      (kurs: {{ ksefOrderInfo.exchangeRateBeforeCorrection | number:'1.2-4' }})
                    </span>
                  </div>
                  <div class="overflow-x-auto border border-red-200 dark:border-red-800/50 rounded-lg">
                    <table class="w-full text-sm">
                      <thead>
                        <tr class="border-b border-red-200 dark:border-red-800/50 bg-red-50 dark:bg-red-900/20">
                          <th class="text-left py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Lp.</th>
                          <th class="text-left py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Nazwa</th>
                          <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Ilość</th>
                          <th class="text-center py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">J.m.</th>
                          <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Cena netto
                          </th>
                          <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Netto</th>
                          <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">VAT</th>
                          <th class="text-center py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Stawka</th>
                          <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Brutto</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of ksefOrderItemsBeforeCorrection; let i = index"
                          class="border-b border-red-100 dark:border-red-900/30 bg-red-50/50 dark:bg-red-900/10">
                          <td class="py-2 px-2 text-gray-500 dark:text-gray-400">{{ item.lp }}</td>
                          <td class="py-2 px-2 text-gray-900 dark:text-white">{{ item.name }}</td>
                          <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.quantity |
                            number:'1.0-4' }}</td>
                          <td class="py-2 px-2 text-center text-gray-500 dark:text-gray-400">{{ item.unit }}</td>
                          <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.unitNetPrice |
                            number:'1.2-2' }}</td>
                          <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.netValue |
                            number:'1.2-2' }}</td>
                          <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.vatValue |
                            number:'1.2-2' }}</td>
                          <td class="py-2 px-2 text-center text-gray-500 dark:text-gray-400">{{
                            formatVatRate(item.vatRate) }}</td>
                          <td class="py-2 px-2 text-right font-medium text-gray-900 dark:text-white">{{ item.grossValue
                            | number:'1.2-2' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Zamówienie PO korekcie -->
                <div class="mb-2">
                  <div class="flex items-center gap-2 mb-3">
                    <div
                      class="flex items-center justify-center w-6 h-6 rounded-full bg-green-100 dark:bg-green-900/40">
                      <mat-icon class="!w-3.5 !h-3.5 text-green-600 dark:text-green-400"
                        [svgIcon]="'tabler_outline:arrow-forward'"></mat-icon>
                    </div>
                    <h4 class="text-sm font-semibold text-green-600 dark:text-green-400">ZAMÓWIENIE PO KOREKCIE</h4>
                    <span *ngIf="ksefOrderInfo.exchangeRate" class="text-xs text-gray-500 dark:text-gray-400 ml-2">
                      (kurs: {{ ksefOrderInfo.exchangeRate | number:'1.2-4' }})
                    </span>
                  </div>
                  <div class="overflow-x-auto border border-green-200 dark:border-green-800/50 rounded-lg">
                    <table class="w-full text-sm">
                      <thead>
                        <tr class="border-b border-green-200 dark:border-green-800/50 bg-green-50 dark:bg-green-900/20">
                          <th class="text-left py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Lp.</th>
                          <th class="text-left py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Nazwa</th>
                          <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Ilość</th>
                          <th class="text-center py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">J.m.</th>
                          <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Cena netto
                          </th>
                          <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Netto</th>
                          <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">VAT</th>
                          <th class="text-center py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Stawka</th>
                          <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Brutto</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of ksefOrderItemsAfterCorrection; let i = index"
                          class="border-b border-green-100 dark:border-green-900/30 bg-green-50/50 dark:bg-green-900/10">
                          <td class="py-2 px-2 text-gray-500 dark:text-gray-400">{{ item.lp }}</td>
                          <td class="py-2 px-2 text-gray-900 dark:text-white">{{ item.name }}</td>
                          <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.quantity |
                            number:'1.0-4' }}</td>
                          <td class="py-2 px-2 text-center text-gray-500 dark:text-gray-400">{{ item.unit }}</td>
                          <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.unitNetPrice |
                            number:'1.2-2' }}</td>
                          <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.netValue |
                            number:'1.2-2' }}</td>
                          <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.vatValue |
                            number:'1.2-2' }}</td>
                          <td class="py-2 px-2 text-center text-gray-500 dark:text-gray-400">{{
                            formatVatRate(item.vatRate) }}</td>
                          <td class="py-2 px-2 text-right font-medium text-gray-900 dark:text-white">{{ item.grossValue
                            | number:'1.2-2' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-container>

              <!-- Zamówienie BEZ podziału (fallback gdy brak StanPrzedZ) -->
              <ng-container *ngIf="!hasOrderCorrectionBeforeAfterItems">
                <h4 class="text-sm font-semibold text-gray-500 dark:text-gray-400 mb-3">POZYCJE ZAMÓWIENIA</h4>
                <div class="overflow-x-auto">
                  <table class="w-full text-sm">
                    <thead>
                      <tr class="border-b border-gray-200 dark:border-gray-700">
                        <th class="text-left py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Lp.</th>
                        <th class="text-left py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Nazwa</th>
                        <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Ilość</th>
                        <th class="text-center py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">J.m.</th>
                        <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Cena netto</th>
                        <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Netto</th>
                        <th class="text-center py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">VAT</th>
                        <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Brutto</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of ksefOrderInfo.items; let i = index"
                        class="border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700/30">
                        <td class="py-2 px-2 text-gray-500 dark:text-gray-400">{{ item.lp }}</td>
                        <td class="py-2 px-2 text-gray-900 dark:text-white">{{ item.name }}</td>
                        <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.quantity |
                          number:'1.0-4' }}</td>
                        <td class="py-2 px-2 text-center text-gray-500 dark:text-gray-400">{{ item.unit }}</td>
                        <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.unitNetPrice |
                          number:'1.2-2' }}</td>
                        <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.netValue |
                          number:'1.2-2' }}</td>
                        <td class="py-2 px-2 text-center text-gray-500 dark:text-gray-400">{{
                          formatVatRate(item.vatRate) }}</td>
                        <td class="py-2 px-2 text-right font-medium text-gray-900 dark:text-white">{{ item.grossValue |
                          number:'1.2-2' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <!-- Pozycje faktury z KSeF XML (dla zwykłych faktur lub zaliczek z pozycjami) -->
          <div class="mb-6"
            *ngIf="(!isKsefAdvanceInvoice && !isKsefAdvanceCorrectionInvoice) || ksefInvoiceItems.length > 0">
            <h4 *ngIf="!hasCorrectionBeforeAfterItems"
              class="text-sm font-semibold text-gray-500 dark:text-gray-400 mb-3">
              {{ isKsefAdvanceInvoice ? 'POZYCJE FAKTURY ZALICZKOWEJ' : 'POZYCJE FAKTURY' }}
            </h4>

            <!-- Ładowanie -->
            <div *ngIf="isLoadingKsefXml"
              class="flex items-center justify-center py-8 text-gray-500 dark:text-gray-400">
              <mat-spinner diameter="24" class="mr-3"></mat-spinner>
              <span>Pobieranie danych z KSeF...</span>
            </div>

            <!-- Brak pozycji - tylko dla zwykłych faktur (nie dla zaliczek/korekt zaliczek bez pozycji) -->
            <div
              *ngIf="!isLoadingKsefXml && ksefInvoiceItems.length === 0 && !isKsefAdvanceInvoice && !isKsefAdvanceCorrectionInvoice"
              class="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4 text-center text-gray-500 dark:text-gray-400">
              <mat-icon class="!w-8 !h-8 mb-2 opacity-50" [svgIcon]="'tabler_outline:file-invoice'"></mat-icon>
              <p class="text-sm">Nie udało się pobrać pozycji faktury</p>
              <button mat-stroked-button color="primary" class="mt-3" (click)="loadKsefXml()">
                <mat-icon [svgIcon]="'tabler_outline:refresh'"></mat-icon>
                <span class="ml-2">Spróbuj ponownie</span>
              </button>
            </div>

            <!-- === KOREKTA: Pozycje PRZED i PO korekcie (gdy StanPrzed jest obecny) === -->
            <ng-container *ngIf="!isLoadingKsefXml && hasCorrectionBeforeAfterItems">

              <!-- Pozycje PRZED korektą -->
              <div class="mb-6">
                <div class="flex items-center gap-2 mb-3">
                  <div class="flex items-center justify-center w-6 h-6 rounded-full bg-red-100 dark:bg-red-900/40">
                    <mat-icon class="!w-3.5 !h-3.5 text-red-600 dark:text-red-400"
                      [svgIcon]="'tabler_outline:arrow-back'"></mat-icon>
                  </div>
                  <h4 class="text-sm font-semibold text-red-600 dark:text-red-400">PRZED KOREKTĄ</h4>
                </div>
                <div class="overflow-x-auto border border-red-200 dark:border-red-800/50 rounded-lg">
                  <table class="w-full text-sm">
                    <thead>
                      <tr class="border-b border-red-200 dark:border-red-800/50 bg-red-50 dark:bg-red-900/20">
                        <th class="text-left py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Lp.</th>
                        <th class="text-left py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Nazwa</th>
                        <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Ilość</th>
                        <th class="text-center py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">J.m.</th>
                        <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Cena netto</th>
                        <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Netto</th>
                        <th class="text-center py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">VAT</th>
                        <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Brutto</th>
                        <th *ngIf="hasExchangeRates"
                          class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Kurs</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of ksefItemsBeforeCorrection; let i = index"
                        class="border-b border-red-100 dark:border-red-900/30 bg-red-50/50 dark:bg-red-900/10">
                        <td class="py-2 px-2 text-gray-500 dark:text-gray-400">{{ item.lp }}</td>
                        <td class="py-2 px-2 text-gray-900 dark:text-white">{{ item.name }}</td>
                        <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.quantity |
                          number:'1.0-4' }}</td>
                        <td class="py-2 px-2 text-center text-gray-500 dark:text-gray-400">{{ item.unit }}</td>
                        <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.unitNetPrice |
                          number:'1.2-2' }}</td>
                        <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.netValue |
                          number:'1.2-2' }}</td>
                        <td class="py-2 px-2 text-center text-gray-500 dark:text-gray-400">{{
                          formatVatRate(item.vatRate) }}</td>
                        <td class="py-2 px-2 text-right font-medium text-gray-900 dark:text-white">{{ item.grossValue |
                          number:'1.2-2' }}</td>
                        <td *ngIf="hasExchangeRates" class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">
                          <span *ngIf="item.exchangeRate">{{ item.exchangeRate | number:'1.2-4' }}</span>
                          <span *ngIf="!item.exchangeRate" class="text-gray-400">-</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Pozycje PO korekcie -->
              <div class="mb-2">
                <div class="flex items-center gap-2 mb-3">
                  <div class="flex items-center justify-center w-6 h-6 rounded-full bg-green-100 dark:bg-green-900/40">
                    <mat-icon class="!w-3.5 !h-3.5 text-green-600 dark:text-green-400"
                      [svgIcon]="'tabler_outline:arrow-forward'"></mat-icon>
                  </div>
                  <h4 class="text-sm font-semibold text-green-600 dark:text-green-400">PO KOREKCIE</h4>
                </div>
                <div class="overflow-x-auto border border-green-200 dark:border-green-800/50 rounded-lg">
                  <table class="w-full text-sm">
                    <thead>
                      <tr class="border-b border-green-200 dark:border-green-800/50 bg-green-50 dark:bg-green-900/20">
                        <th class="text-left py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Lp.</th>
                        <th class="text-left py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Nazwa</th>
                        <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Ilość</th>
                        <th class="text-center py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">J.m.</th>
                        <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Cena netto</th>
                        <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Netto</th>
                        <th class="text-center py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">VAT</th>
                        <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Brutto</th>
                        <th *ngIf="hasExchangeRates"
                          class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Kurs</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of ksefItemsAfterCorrection; let i = index"
                        class="border-b border-green-100 dark:border-green-900/30 bg-green-50/50 dark:bg-green-900/10">
                        <td class="py-2 px-2 text-gray-500 dark:text-gray-400">{{ item.lp }}</td>
                        <td class="py-2 px-2 text-gray-900 dark:text-white">{{ item.name }}</td>
                        <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.quantity |
                          number:'1.0-4' }}</td>
                        <td class="py-2 px-2 text-center text-gray-500 dark:text-gray-400">{{ item.unit }}</td>
                        <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.unitNetPrice |
                          number:'1.2-2' }}</td>
                        <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.netValue |
                          number:'1.2-2' }}</td>
                        <td class="py-2 px-2 text-center text-gray-500 dark:text-gray-400">{{
                          formatVatRate(item.vatRate) }}</td>
                        <td class="py-2 px-2 text-right font-medium text-gray-900 dark:text-white">{{ item.grossValue |
                          number:'1.2-2' }}</td>
                        <td *ngIf="hasExchangeRates" class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">
                          <span *ngIf="item.exchangeRate">{{ item.exchangeRate | number:'1.2-4' }}</span>
                          <span *ngIf="!item.exchangeRate" class="text-gray-400">-</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </ng-container>

            <!-- === ZWYKŁA TABELA: Gdy brak StanPrzed (zwykłe faktury lub korekty wartościowe) === -->
            <div *ngIf="!isLoadingKsefXml && ksefInvoiceItems.length > 0 && !hasCorrectionBeforeAfterItems"
              class="overflow-x-auto">
              <table class="w-full text-sm">
                <thead>
                  <tr class="border-b border-gray-200 dark:border-gray-700">
                    <th class="text-left py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Lp.</th>
                    <th class="text-left py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Nazwa</th>
                    <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Ilość</th>
                    <th class="text-center py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">J.m.</th>
                    <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Cena netto</th>
                    <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Netto</th>
                    <th class="text-center py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">VAT</th>
                    <th class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Brutto</th>
                    <th *ngIf="hasExchangeRates"
                      class="text-right py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Kurs</th>
                    <th *ngIf="hasDeliveryDates"
                      class="text-center py-2 px-2 font-semibold text-gray-600 dark:text-gray-400">Data dostawy</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of ksefInvoiceItems; let i = index"
                    class="border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700/30">
                    <td class="py-2 px-2 text-gray-500 dark:text-gray-400">{{ item.lp }}</td>
                    <td class="py-2 px-2 text-gray-900 dark:text-white">{{ item.name }}</td>
                    <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.quantity | number:'1.0-4'
                      }}</td>
                    <td class="py-2 px-2 text-center text-gray-500 dark:text-gray-400">{{ item.unit }}</td>
                    <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.unitNetPrice |
                      number:'1.2-2' }}</td>
                    <td class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">{{ item.netValue | number:'1.2-2'
                      }}</td>
                    <td class="py-2 px-2 text-center text-gray-500 dark:text-gray-400">{{ formatVatRate(item.vatRate) }}
                    </td>
                    <td class="py-2 px-2 text-right font-medium text-gray-900 dark:text-white">{{ item.grossValue |
                      number:'1.2-2' }}</td>
                    <td *ngIf="hasExchangeRates" class="py-2 px-2 text-right text-gray-700 dark:text-gray-300">
                      <span *ngIf="item.exchangeRate">{{ item.exchangeRate | number:'1.2-4' }}</span>
                      <span *ngIf="!item.exchangeRate" class="text-gray-400">-</span>
                    </td>
                    <td *ngIf="hasDeliveryDates" class="py-2 px-2 text-center text-gray-500 dark:text-gray-400">
                      <date-formatter *ngIf="item.deliveryDate" [date]="item.deliveryDate"></date-formatter>
                      <span *ngIf="!item.deliveryDate">-</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Dane płatności z KSeF -->
          <div *ngIf="ksefPaymentInfo" class="mb-6">
            <h4 class="text-sm font-semibold text-gray-500 dark:text-gray-400 mb-3">PŁATNOŚĆ</h4>
            <div class="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4">
              <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                <!-- Forma płatności -->
                <div class="flex items-center gap-3">
                  <div
                    class="w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900/40 flex items-center justify-center flex-shrink-0">
                    <mat-icon class="!w-5 !h-5 text-blue-600 dark:text-blue-400"
                      [svgIcon]="'tabler_outline:credit-card'"></mat-icon>
                  </div>
                  <div>
                    <div class="text-xs text-blue-600 dark:text-blue-400">Forma płatności</div>
                    <div class="font-medium text-gray-900 dark:text-white">{{ ksefPaymentInfo.paymentMethodName }}</div>
                  </div>
                </div>

                <!-- Termin płatności -->
                <div *ngIf="ksefPaymentInfo.paymentDeadline" class="flex items-center gap-3">
                  <div
                    class="w-10 h-10 rounded-lg bg-orange-100 dark:bg-orange-900/40 flex items-center justify-center flex-shrink-0">
                    <mat-icon class="!w-5 !h-5 text-orange-600 dark:text-orange-400"
                      [svgIcon]="'tabler_outline:calendar-due'"></mat-icon>
                  </div>
                  <div>
                    <div class="text-xs text-orange-600 dark:text-orange-400">Termin płatności</div>
                    <div class="font-medium text-gray-900 dark:text-white">{{
                      formatDateHuman(ksefPaymentInfo.paymentDeadline) }}</div>
                  </div>
                </div>

                <!-- Status zapłaty -->
                <div class="flex items-center gap-3">
                  <div class="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" [ngClass]="{
                         'bg-green-100 dark:bg-green-900/40': ksefPaymentInfo.isPaid,
                         'bg-gray-100 dark:bg-gray-700/40': !ksefPaymentInfo.isPaid
                       }">
                    <mat-icon class="!w-5 !h-5" [ngClass]="{
                                'text-green-600 dark:text-green-400': ksefPaymentInfo.isPaid,
                                'text-gray-500 dark:text-gray-400': !ksefPaymentInfo.isPaid
                              }"
                      [svgIcon]="ksefPaymentInfo.isPaid ? 'tabler_outline:circle-check' : 'tabler_outline:clock'"></mat-icon>
                  </div>
                  <div>
                    <div class="text-xs" [ngClass]="{
                           'text-green-600 dark:text-green-400': ksefPaymentInfo.isPaid,
                           'text-gray-500 dark:text-gray-400': !ksefPaymentInfo.isPaid
                         }">
                      Status płatności
                    </div>
                    <div class="font-medium text-gray-900 dark:text-white">
                      {{ ksefPaymentInfo.isPaid ? 'Zapłacono' : 'Do zapłaty' }}
                      <span *ngIf="ksefPaymentInfo.isPaid && ksefPaymentInfo.paidDate"
                        class="text-sm text-gray-500 dark:text-gray-400">
                        ({{ formatDateHuman(ksefPaymentInfo.paidDate) }})
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Numer konta bankowego -->
                <div *ngIf="ksefPaymentInfo.bankAccountNumber"
                  class="flex items-center gap-3 sm:col-span-2 lg:col-span-3">
                  <div
                    class="w-10 h-10 rounded-lg bg-indigo-100 dark:bg-indigo-900/40 flex items-center justify-center flex-shrink-0">
                    <mat-icon class="!w-5 !h-5 text-indigo-600 dark:text-indigo-400"
                      [svgIcon]="'tabler_outline:building-bank'"></mat-icon>
                  </div>
                  <div>
                    <div class="text-xs text-indigo-600 dark:text-indigo-400">Numer konta</div>
                    <div class="font-medium font-mono text-gray-900 dark:text-white">{{
                      formatBankAccount(ksefPaymentInfo.bankAccountNumber) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Numer KSeF i metadane - rozwijane -->
          <details class="bg-green-50 dark:bg-green-900/20 rounded-lg">
            <summary
              class="p-4 cursor-pointer select-none flex items-center justify-between hover:bg-green-100 dark:hover:bg-green-900/30 rounded-lg transition-colors">
              <span class="text-sm font-semibold text-green-700 dark:text-green-400">Szczegółowe dane KSeF</span>
              <mat-icon class="!w-5 !h-5 text-green-600 dark:text-green-400 transition-transform"
                [svgIcon]="'tabler_outline:chevron-down'"></mat-icon>
            </summary>
            <div class="px-4 pb-4 space-y-2 text-sm">
              <div class="flex flex-col sm:flex-row sm:justify-between gap-1">
                <span class="text-green-600 dark:text-green-400">Numer KSeF:</span>
                <div class="flex items-center gap-2">
                  <span class="font-mono text-green-800 dark:text-green-300 break-all">{{ document?.ksefNumber }}</span>
                  <button type="button"
                    class="p-1 rounded hover:bg-green-200 dark:hover:bg-green-800/50 transition-colors"
                    matTooltip="Kopiuj numer KSeF" (click)="copyKsefNumber()">
                    <mat-icon class="!w-4 !h-4 text-green-600 dark:text-green-400"
                      [svgIcon]="'tabler_outline:copy'"></mat-icon>
                  </button>
                </div>
              </div>
              <div class="flex flex-col sm:flex-row sm:justify-between gap-1" *ngIf="ksefRawData?.acquisitionDate">
                <span class="text-green-600 dark:text-green-400">Data przyjęcia w KSeF:</span>
                <span class="text-green-800 dark:text-green-300"><date-formatter [date]="ksefRawData?.acquisitionDate"
                    [showTime]="true"></date-formatter></span>
              </div>
              <div class="flex flex-col sm:flex-row sm:justify-between gap-1" *ngIf="ksefRawData?.invoicingMode">
                <span class="text-green-600 dark:text-green-400">Tryb fakturowania:</span>
                <span class="text-green-800 dark:text-green-300">{{ ksefRawData?.invoicingMode }}</span>
              </div>
              <div class="flex flex-col sm:flex-row sm:justify-between gap-1" *ngIf="ksefRawData?.invoiceHash">
                <span class="text-green-600 dark:text-green-400">Hash faktury:</span>
                <span class="font-mono text-xs text-green-800 dark:text-green-300 break-all">{{ ksefRawData?.invoiceHash
                  }}</span>
              </div>
              <div
                class="flex flex-col sm:flex-row sm:justify-between gap-1 pt-2 mt-2 border-t border-green-200 dark:border-green-800/50"
                *ngIf="document?.createdAt">
                <span class="text-green-600 dark:text-green-400">Zsynchronizowano:</span>
                <span class="text-green-800 dark:text-green-300"><date-formatter [date]="document?.createdAt"
                    [showTime]="true"></date-formatter></span>
              </div>
            </div>
          </details>

          <!-- Podgląd RAW JSON i XML -->
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
            <!-- Podgląd RAW JSON -->
            <button type="button"
              class="bg-gray-100 dark:bg-gray-700/50 rounded-lg p-4 text-left hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors cursor-pointer group"
              (click)="showKsefRawData()">
              <div class="flex items-center justify-between mb-2">
                <div class="flex items-center gap-2">
                  <mat-icon class="!w-5 !h-5 text-amber-600 dark:text-amber-400"
                    [svgIcon]="'tabler_outline:braces'"></mat-icon>
                  <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">RAW JSON</span>
                </div>
                <mat-icon class="!w-4 !h-4 text-gray-400 group-hover:text-primary transition-colors"
                  [svgIcon]="'tabler_outline:external-link'"></mat-icon>
              </div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Dane faktury w formacie JSON</p>
            </button>

            <!-- Podgląd XML -->
            <button type="button"
              class="bg-gray-100 dark:bg-gray-700/50 rounded-lg p-4 text-left hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors cursor-pointer group"
              [class.opacity-50]="!ksefXmlContent && !document?.ksefMetadata?.rawXml"
              [disabled]="!ksefXmlContent && !document?.ksefMetadata?.rawXml" (click)="showKsefXml()">
              <div class="flex items-center justify-between mb-2">
                <div class="flex items-center gap-2">
                  <mat-icon class="!w-5 !h-5 text-blue-600 dark:text-blue-400"
                    [svgIcon]="'tabler_outline:file-type-xml'"></mat-icon>
                  <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">XML KSeF</span>
                </div>
                <mat-icon class="!w-4 !h-4 text-gray-400 group-hover:text-primary transition-colors"
                  [svgIcon]="'tabler_outline:external-link'"></mat-icon>
              </div>
              <p class="text-xs text-gray-500 dark:text-gray-400">
                {{ (ksefXmlContent || document?.ksefMetadata?.rawXml) ? 'Oryginalny XML faktury' : 'Pobierz najpierw
                XML' }}
              </p>
            </button>
          </div>
        </div>
      </ng-container>

      <!-- === PODGLĄD DLA LOKALNYCH FAKTUR (PDF) === -->
      <ng-container *ngIf="!isKsefDocument">
        <mat-spinner class="mx-auto" *ngIf="!dataUrl"></mat-spinner>
        <div *ngIf="dataUrl" class="preview-container" [class.opacity-0]="isPdfLoaded === null"
          [class.opacity-100]="isPdfLoaded !== null">
          <ngx-extended-pdf-viewer *ngIf="dataUrl !== null" [base64Src]="dataUrl" (pdfLoaded)="onPdfLoaded($event)"
            backgroundColor="#d8d8d8" [forceFullReloadOfJavaScriptCode]="true" [height]="pdfPreviewHeight"
            [showToolbar]="false" [showSidebarButton]="false" [showFindButton]="false" [showPagingButtons]="false"
            [showDrawEditor]="false" [showStampEditor]="false" [showTextEditor]="false" [showZoomButtons]="false"
            [showPresentationModeButton]="false" [showOpenFileButton]="false" [showPrintButton]="false"
            [showDownloadButton]="false" [showSecondaryToolbarButton]="false" [showRotateButton]="false"
            [showRotateCwButton]="false" [showRotateCcwButton]="false" [showHandToolButton]="false"
            [showSpreadButton]="false" [showPropertiesButton]="false" [zoom]="'auto'">
          </ngx-extended-pdf-viewer>



          <!-- <pdf-viewer src="previewData" style="display:block; width: 100%; height: 1500px;"></pdf-viewer> -->
          <!-- <iframe *ngIf="previewData" s class="mx-auto" width="100%" height="1500" style="overflow:hidden; overflow-y:hidden;" [src]="previewData"></iframe> -->
        </div>
      </ng-container>
    </div>

    <div class="order-first sm:order-last">
      <div data-tour-id="wyslij-ksef">
        <ng-container *ngIf="ksefEnabled">

          <!-- 🚨 CONNECTION ERROR STATE - Połączenie dezaktywowane (tylko gdy dokument NIE został wysłany) -->
          <div
            *ngIf="ksefConnectionStatus && !ksefConnectionStatus.isAuthorized && !isProforma && !isOrderDocument && ksefStatus !== 'success'"
            class="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-red-200 dark:border-red-800 p-5 w-full sm:max-w-72 mb-4">
            <div class="flex items-center gap-3 mb-4">
              <div
                class="w-12 h-12 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center flex-shrink-0">
                <mat-icon class="!w-6 !h-6 text-red-600 dark:text-red-400"
                  [svgIcon]="'tabler_outline:plug-connected-x'"></mat-icon>
              </div>
              <div>
                <h3 class="text-base font-semibold text-red-700 dark:text-red-400">Połączenie nieaktywne</h3>
                <p class="text-xs text-gray-500 dark:text-gray-400">Wymagana konfiguracja</p>
              </div>
            </div>

            <p class="text-sm text-gray-600 dark:text-gray-300 mb-4">
              Skonfiguruj połączenie, aby móc wysyłać faktury.
            </p>

            <div *ngIf="ksefConnectionStatus.lastError"
              class="bg-red-50 dark:bg-red-900/20 rounded-lg p-3 mb-4 text-xs text-red-700 dark:text-red-300">
              <div class="font-medium mb-1">Ostatni błąd:</div>
              <div class="break-words">{{ ksefConnectionStatus.lastError }}</div>
            </div>

            <button mat-flat-button color="primary" class="w-full" (click)="goToKsefSettings()">
              <mat-icon [svgIcon]="'tabler_outline:settings'"></mat-icon>
              <span class="ml-2">Skonfiguruj KSeF</span>
            </button>
          </div>

          <!-- KSeF Status Card (tylko dla faktur VAT, NIE dla proform, NIE dla zamówień, NIE dla kosztów, NIE dla pobranych z KSeF, NIE dla Faktura bez VAT!) -->
          <!-- Pokazuj dla SUCCESS zawsze (tylko przychody), dla innych stanów tylko gdy połączenie aktywne -->
          <div
            *ngIf="(document?.isPaid || canIssueAndSendToKsef) && !isProforma && !isOrderDocument && document?.documentType !== 'Faktura' && document?.direction !== 'expense' && !isKsefDocument && (ksefStatus === 'success' || ksefConnectionStatus?.isAuthorized)"
            class="relative rounded-xl shadow-lg p-5 w-full sm:max-w-72 mb-4 overflow-hidden transition-colors"
            [ngClass]="(ksefStatus === 'not-sent' && !isIssueDateExpired && (canSendToKsef || canIssueAndSendToKsef) && ksefClientWarnings.length > 0) 
              ? 'bg-amber-50 dark:bg-amber-900/20 border border-amber-300 dark:border-amber-700/60' 
              : 'bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700'"
            [style.minHeight]="(isSendingToKsef || ksefSuccessOverlay) ? '180px' : null">

            <!-- ============ OVERLAY SUKCESU (animowany) ============ -->
            <div *ngIf="ksefSuccessOverlay"
              class="absolute inset-0 z-10 flex flex-col items-center justify-center bg-white dark:bg-gray-800 rounded-xl p-5 animate-ksef-success-in">
              <!-- Animated checkmark -->
              <div class="relative mb-3">
                <div
                  class="w-14 h-14 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center animate-ksef-check-pop">
                  <svg class="w-7 h-7 text-green-500" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12" class="animate-ksef-check-draw"></polyline>
                  </svg>
                </div>
                <!-- Pulse ring -->
                <div class="absolute inset-0 rounded-full border-2 border-green-400/50 animate-ksef-pulse-ring"></div>
              </div>

              <h3 class="text-sm font-bold text-green-700 dark:text-green-400 mb-1">Wysłano do KSeF!</h3>

              <!-- Numer KSeF z animacją -->
              <div *ngIf="ksefSuccessKsefNumber"
                class="flex items-center gap-1.5 bg-green-50 dark:bg-green-900/20 rounded-lg px-3 py-2 mt-2 mb-3 max-w-full animate-ksef-number-slide">
                <mat-icon class="!w-4 !h-4 text-green-600 flex-shrink-0" [svgIcon]="'ksef:ksef-logo'"></mat-icon>
                <span class="font-mono text-[10px] text-green-800 dark:text-green-300 truncate"
                  [matTooltip]="ksefSuccessKsefNumber">{{ ksefSuccessKsefNumber }}</span>
                <button mat-icon-button class="!w-6 !h-6 flex-shrink-0" matTooltip="Kopiuj numer KSeF"
                  (click)="copyKsefNumberFromOverlay()">
                  <mat-icon class="!w-3 !h-3 text-green-600" [svgIcon]="'tabler_outline:copy'"></mat-icon>
                </button>
              </div>

              <button mat-button class="text-xs text-gray-500" (click)="dismissKsefSuccessOverlay()">
                Zamknij
              </button>
            </div>

            <!-- ============ OVERLAY ŁADOWANIA (sending) ============ -->
            <div *ngIf="isSendingToKsef && !ksefSuccessOverlay"
              class="absolute inset-0 z-10 flex flex-col items-center justify-center bg-white/95 dark:bg-gray-800/95 backdrop-blur-sm rounded-xl p-5">
              <div class="relative mb-3">
                <div class="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  <mat-icon class="!w-5 !h-5 text-primary animate-pulse" [svgIcon]="'ksef:ksef-logo'"></mat-icon>
                </div>
                <mat-spinner diameter="48" class="!absolute !top-0 !left-0"></mat-spinner>
              </div>
              <p class="text-sm font-medium text-gray-700 dark:text-gray-300">Wysyłanie do KSeF...</p>
              <p class="text-[11px] text-gray-400 mt-1">To może potrwać do minuty</p>
            </div>

            <!-- SUCCESS STATE -->
            <div *ngIf="ksefStatus === 'success'">
              <div class="flex items-center gap-3 mb-4">
                <div
                  class="w-12 h-12 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center flex-shrink-0">
                  <mat-icon class="!w-6 !h-6 text-green-600 dark:text-green-400"
                    [svgIcon]="'tabler_outline:circle-check'"></mat-icon>
                </div>
                <div>
                  <h3 class="text-base font-semibold text-green-700 dark:text-green-400">Wysłano do KSeF</h3>
                  <p class="text-xs text-gray-500 dark:text-gray-400">Faktura zarejestrowana</p>
                </div>
              </div>

              <!-- Numer KSeF -->
              <div *ngIf="document?.ksefNumber"
                class="flex items-center gap-1.5 bg-gray-50 dark:bg-gray-700/50 rounded-lg px-3 py-2 mb-3">
                <div class="font-mono text-[10px] text-gray-800 dark:text-gray-200 truncate flex-1 min-w-0"
                  [matTooltip]="document?.ksefNumber || ''">{{ document?.ksefNumber }}</div>
                <button mat-icon-button class="!w-7 !h-7 flex-shrink-0" matTooltip="Kopiuj numer KSeF"
                  (click)="copyKsefNumber()">
                  <mat-icon class="!w-3.5 !h-3.5" [svgIcon]="'tabler_outline:copy'"></mat-icon>
                </button>
              </div>

              <!-- Data wysyłki + XML -->
              <div class="flex items-center justify-between">
                <div *ngIf="document?.ksefSentAt" class="text-[11px] text-gray-500 dark:text-gray-400">
                  Wysłano: <date-formatter [date]="document?.ksefSentAt" [showTime]="true"></date-formatter>
                </div>
                <button *ngIf="document?.ksefNumber" mat-icon-button class="!w-8 !h-8 flex-shrink-0"
                  matTooltip="Pobierz XML z KSeF" (click)="openKsefInvoicePreview()">
                  <mat-icon class="!w-4 !h-4 text-gray-400 dark:text-gray-500"
                    [svgIcon]="'tabler_outline:file-code'"></mat-icon>
                </button>
              </div>
            </div>

            <!-- PENDING STATE (wysyłka w toku / oczekuje na przetworzenie) -->
            <div *ngIf="ksefStatus === 'pending'">
              <div class="flex items-center gap-3 mb-4">
                <div
                  class="w-10 h-10 rounded-xl bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center flex-shrink-0">
                  <mat-icon class="!w-5 !h-5 text-amber-600 dark:text-amber-400 animate-pulse"
                    [svgIcon]="'ksef:ksef-logo'"></mat-icon>
                </div>
                <div>
                  <h3 class="text-sm font-semibold text-on-surface">Trwa przetwarzanie</h3>
                  <p class="text-[11px] text-gray-400 dark:text-gray-500">Faktura została wysłana do KSeF</p>
                </div>
              </div>

              <div class="flex items-center gap-2 px-3 py-2 rounded-lg bg-amber-50 dark:bg-amber-900/15">
                <mat-spinner diameter="12" class="flex-shrink-0"></mat-spinner>
                <span class="text-xs text-amber-700 dark:text-amber-400">Oczekuje na potwierdzenie z KSeF</span>
              </div>
            </div>

            <!-- ERROR STATE -->
            <div *ngIf="ksefStatus === 'error'">
              <div class="flex items-center gap-3 mb-4">
                <div
                  class="w-12 h-12 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center flex-shrink-0">
                  <mat-icon class="!w-6 !h-6 text-red-600 dark:text-red-400"
                    [svgIcon]="'tabler_outline:alert-circle'"></mat-icon>
                </div>
                <div>
                  <h3 class="text-base font-semibold text-red-700 dark:text-red-400">Błąd wysyłki</h3>
                  <p class="text-xs text-gray-500 dark:text-gray-400">Wystąpił problem</p>
                </div>
              </div>

              <!-- Szczegóły błędu -->
              <div *ngIf="document?.ksefError" class="bg-red-50 dark:bg-red-900/20 rounded-lg p-3 mb-3">
                <div class="text-xs text-red-700 dark:text-red-400">
                  <div class="font-medium mb-1">Błąd {{ document?.ksefError?.code }}</div>
                  <div class="break-words">{{ document?.ksefError?.message }}</div>
                </div>
                <div *ngIf="document?.ksefError?.details && (document?.ksefError?.details?.length ?? 0) > 0"
                  class="text-xs text-red-600 dark:text-red-400 mt-2 space-y-0.5">
                  <div *ngFor="let detail of document?.ksefError?.details || []" class="flex items-start">
                    <span class="mr-1">•</span>
                    <span>{{ detail }}</span>
                  </div>
                </div>
              </div>

              <!-- Przyciski -->
              <div class="space-y-2">
                <button mat-flat-button color="primary" class="w-full" [disabled]="isSendingToKsef"
                  (click)="sendToKsef()">
                  <mat-icon *ngIf="!isSendingToKsef" [svgIcon]="'tabler_outline:reload'"></mat-icon>
                  <mat-spinner diameter="16" *ngIf="isSendingToKsef" class="mr-2"></mat-spinner>
                  <span class="ml-2" *ngIf="!isSendingToKsef">Spróbuj ponownie</span>
                  <span *ngIf="isSendingToKsef">Wysyłanie...</span>
                </button>
              </div>
            </div>

            <!-- NOT SENT STATE - DATA PRZETERMINOWANA (data wystawienia wcześniejsza niż dzisiaj) -->
            <div *ngIf="ksefStatus === 'not-sent' && (canSendToKsef || canIssueAndSendToKsef) && isIssueDateExpired">
              <div class="flex items-center gap-3 mb-4">
                <div
                  class="w-12 h-12 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center flex-shrink-0">
                  <mat-icon class="!w-6 !h-6 text-amber-600 dark:text-amber-400"
                    [svgIcon]="'tabler_outline:alert-triangle'"></mat-icon>
                </div>
                <div>
                  <h3 class="text-base font-semibold text-amber-700 dark:text-amber-400">Data wystawienia
                    przeterminowana</h3>
                  <p class="text-xs text-gray-500 dark:text-gray-400">Wymaga aktualizacji</p>
                </div>
              </div>

              <div
                class="bg-amber-50 dark:bg-amber-900/20 rounded-lg p-3 mb-3 text-xs text-amber-700 dark:text-amber-300">
                <p class="font-medium mb-1">Nie można wysłać do KSeF</p>
                <p>Data wystawienia faktury ({{ document?.issueDate | date:'dd.MM.yyyy' }}) jest wcześniejsza niż
                  dzisiejsza. Zaktualizuj datę wystawienia na dzisiejszą, aby móc wysłać fakturę do KSeF.</p>
              </div>

              <button mat-flat-button color="primary" class="w-full" [routerLink]="'/konto/dokumenty/' + invoice?._id">
                <mat-icon [svgIcon]="'tabler_outline:pencil'"></mat-icon>
                <span class="ml-2">Edytuj dokument</span>
              </button>
            </div>

            <!-- NOT SENT STATE - GOTOWE DO WYSŁANIA (data wystawienia dzisiejsza, dokument wystawiony) -->
            <div *ngIf="ksefStatus === 'not-sent' && canSendToKsef && !isIssueDateExpired" class="-m-5">
              <button class="group relative w-full flex items-center gap-3 px-5 py-4 rounded-xl overflow-hidden cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed
                     bg-gradient-to-r from-primary via-primary to-blue-500
                     hover:from-primary-400 hover:via-primary hover:to-blue-400
                     shadow-lg shadow-primary/25 hover:shadow-xl hover:shadow-primary/40
                     transition-all duration-300 hover:scale-[1.01] active:scale-100" [disabled]="isSendingToKsef"
                (click)="sendToKsef()">
                <div class="w-10 h-10 rounded-xl bg-white/90 flex items-center justify-center flex-shrink-0">
                  <mat-icon class="!w-5 !h-5 text-primary" [svgIcon]="'ksef:ksef-logo'"></mat-icon>
                </div>
                <div class="flex-1 text-left min-w-0">
                  <span class="text-[13px] font-semibold text-white block leading-tight">Wyślij do KSeF</span>
                </div>
                <mat-icon *ngIf="!isSendingToKsef"
                  class="!w-5 !h-5 text-white/70 group-hover:text-white transition-colors flex-shrink-0"
                  [svgIcon]="'tabler_outline:chevron-right'"></mat-icon>
                <mat-spinner *ngIf="isSendingToKsef" diameter="18" class="flex-shrink-0"></mat-spinner>
                <!-- Shine effect -->
                <div
                  class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700">
                </div>
              </button>
            </div>

            <!-- NOT SENT STATE - SZKIC GOTOWY DO WYSTAWIENIA I WYSŁANIA (data dzisiejsza, szkic) -->
            <div *ngIf="ksefStatus === 'not-sent' && canIssueAndSendToKsef && !isIssueDateExpired" class="-m-5">
              <button class="group relative w-full flex items-center gap-3 px-5 py-4 rounded-xl overflow-hidden cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed
                     bg-gradient-to-r from-primary via-primary to-blue-500
                     hover:from-primary-400 hover:via-primary hover:to-blue-400
                     shadow-lg shadow-primary/25 hover:shadow-xl hover:shadow-primary/40
                     transition-all duration-300 hover:scale-[1.01] active:scale-100" [disabled]="isSendingToKsef"
                (click)="issueAndSendToKsef()">
                <div class="w-10 h-10 rounded-xl bg-white/90 flex items-center justify-center flex-shrink-0">
                  <mat-icon class="!w-5 !h-5 text-primary" [svgIcon]="'ksef:ksef-logo'"></mat-icon>
                </div>
                <div class="flex-1 text-left min-w-0">
                  <span class="text-[13px] font-semibold text-white block leading-tight">Wystaw i wyślij do KSeF</span>
                </div>
                <mat-icon *ngIf="!isSendingToKsef"
                  class="!w-5 !h-5 text-white/70 group-hover:text-white transition-colors flex-shrink-0"
                  [svgIcon]="'tabler_outline:chevron-right'"></mat-icon>
                <mat-spinner *ngIf="isSendingToKsef" diameter="18" class="flex-shrink-0"></mat-spinner>
                <!-- Shine effect -->
                <div
                  class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700">
                </div>
              </button>
            </div>

            <!-- Wykryto problemy z KSeF dla przycisków wysyłki -->
            <div
              *ngIf="ksefStatus === 'not-sent' && !isIssueDateExpired && (canSendToKsef || canIssueAndSendToKsef) && ksefClientWarnings.length > 0"
              class="mt-6 pt-5 border-t border-amber-200/60 dark:border-amber-800/60">

              <div class="flex items-center gap-2 mb-4 text-amber-600 dark:text-amber-400 animate-ksef-shake">
                <mat-icon class="!w-5 !h-5 text-amber-500" [svgIcon]="'tabler_outline:alert-triangle'"></mat-icon>
                <h4 class="text-[13px] font-bold uppercase tracking-wider">{{ ksefClientWarnings.length > 1 ? 'Wykryto
                  problemy' : 'Wykryto problem' }}</h4>
              </div>

              <div class="flex flex-col gap-3">
                <div *ngFor="let problem of ksefClientWarnings"
                  class="bg-white/60 dark:bg-black/20 rounded-xl p-3.5 border border-amber-200/50 dark:border-amber-800/40 shadow-sm">
                  <div
                    class="text-[11px] font-bold text-amber-800 dark:text-amber-300 uppercase tracking-widest mb-2.5 opacity-90">
                    {{ problem.role }}
                  </div>
                  <ul class="space-y-2">
                    <li *ngFor="let warning of problem.warnings"
                      class="flex items-start gap-2 text-xs text-amber-900/90 dark:text-amber-100/80">
                      <div class="w-1.5 h-1.5 rounded-full bg-amber-500 dark:bg-amber-400 mt-1 flex-shrink-0"></div>
                      <span class="leading-snug font-medium">{{ warning }}</span>
                    </li>
                  </ul>
                </div>
              </div>

            </div>

          </div>
        </ng-container>
      </div>

      <div class="bg-card rounded-xl shadow-lg p-4 w-full sm:max-w-72" data-tour-id="akcje-dokumentu">

        <!-- === NARZĘDZIA DLA FAKTUR Z KSeF === -->
        <ng-container *ngIf="isKsefDocument">
          <div class="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-3 mb-4">
            <div class="flex items-start gap-2">
              <mat-icon class="!w-5 !h-5 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5"
                [svgIcon]="'tabler_outline:info-circle'"></mat-icon>
              <div class="text-sm text-blue-700 dark:text-blue-300">
                <p class="font-medium mb-1">Faktura pobrana z KSeF</p>
                <p class="text-xs text-blue-600 dark:text-blue-400">Ten dokument został zsynchronizowany z Krajowego
                  Systemu e-Faktur i nie został wygenerowany w tym programie.</p>
              </div>
            </div>
          </div>

          <!-- ALERT: Faktura po terminie płatności -->
          <div *ngIf="isPaymentOverdue"
            class="bg-red-50 dark:bg-red-900/20 rounded-lg p-3 mb-4 border border-red-200 dark:border-red-800">
            <div class="flex items-start gap-2">
              <mat-icon class="!w-5 !h-5 text-red-600 dark:text-red-400 flex-shrink-0 mt-0.5"
                [svgIcon]="'tabler_outline:alert-circle'"></mat-icon>
              <div class="text-sm text-red-700 dark:text-red-300">
                <p class="font-medium">Faktura po terminie płatności</p>
                <p class="text-xs text-red-600 dark:text-red-400 mt-1">Termin płatności: {{
                  document?.paymentDeadline?.value | date:'dd.MM.yyyy' }}</p>
              </div>
            </div>
          </div>

          <!-- Status płatności -->
          <div class="tool-link flex items-center" *ngIf="canMarkAsPaid" (click)="markDocumentAsPaid()">
            <mat-icon color="primary" svgIcon="tabler_outline:cash"></mat-icon>
            Oznacz jako opłacone
          </div>
          <div class="tool-link flex items-center text-red-600" *ngIf="canMarkAsUnpaid"
            (click)="markDocumentAsUnpaid()">
            <mat-icon class="text-red-600" svgIcon="tabler_outline:circle-x"></mat-icon>
            Oznacz jako do zapłaty
          </div>

          <br *ngIf="canMarkAsPaid || canMarkAsUnpaid" />

          <!-- Pobierz XML -->
          <div class="tool-link flex items-center" (click)="downloadKsefXml()">
            <mat-icon color="primary" svgIcon="tabler_outline:file-type-xml"></mat-icon>
            Pobierz XML z KSeF
          </div>

          <!-- Kopiuj numer KSeF -->
          <div class="tool-link flex items-center" (click)="copyKsefNumber()">
            <mat-icon color="primary" svgIcon="tabler_outline:copy"></mat-icon>
            Kopiuj numer KSeF
          </div>
        </ng-container>

        <!-- === NARZĘDZIA DLA LOKALNYCH FAKTUR === -->
        <ng-container *ngIf="!isKsefDocument">

          <!-- ALERT: Faktura po terminie płatności -->
          <div *ngIf="isPaymentOverdue"
            class="bg-red-50 dark:bg-red-900/20 rounded-lg p-3 mb-4 border border-red-200 dark:border-red-800">
            <div class="flex items-start gap-2">
              <mat-icon class="!w-5 !h-5 text-red-600 dark:text-red-400 flex-shrink-0 mt-0.5"
                [svgIcon]="'tabler_outline:alert-circle'"></mat-icon>
              <div class="text-sm text-red-700 dark:text-red-300">
                <p class="font-medium">Faktura po terminie płatności</p>
                <p class="text-xs text-red-600 dark:text-red-400 mt-1">Termin płatności: {{
                  document?.paymentDeadline?.value | date:'dd.MM.yyyy' }}</p>
              </div>
            </div>
          </div>

          <!-- Status płatności - na górze -->
          <div class="tool-link flex items-center" *ngIf="canMarkAsPaid" (click)="markDocumentAsPaid()">
            <mat-icon color="primary" svgIcon="tabler_outline:cash"></mat-icon>
            Oznacz jako opłacone
          </div>
          <div class="tool-link flex items-center text-red-600" *ngIf="canMarkAsUnpaid"
            (click)="markDocumentAsUnpaid()">
            <mat-icon class="text-red-600" svgIcon="tabler_outline:circle-x"></mat-icon>
            Oznacz jako do zapłaty
          </div>

          <br *ngIf="canMarkAsPaid || canMarkAsUnpaid" />

          <div class="tool-link flex items-center" *ngIf="!document?.isPaid" (click)="markAsPaidOrTemplate(true)">
            <mat-icon color="primary" svgIcon="tabler_outline:check"></mat-icon>
            Oznacz jako wystawiony
          </div>
          <div class="tool-link flex items-center" [routerLink]="'/konto/dokumenty/wystaw'">
            <mat-icon color="primary" svgIcon="tabler_outline:plus"></mat-icon>
            Nowa faktura
          </div>
          <!-- Przycisk dla Zamówienia - wystaw fakturę zaliczkową -->
          <div class="tool-link flex items-center" *ngIf="document?.documentType === 'Zamowienie'"
            [routerLink]="'/konto/dokumenty/wystaw'" [queryParams]="{ advanceForOrderId: invoice?._id }">
            <mat-icon color="primary" svgIcon="tabler_outline:receipt-2"></mat-icon>
            Wystaw fakturę zaliczkową
          </div>
          <!-- Przycisk dla FakturaZaliczka - wystaw fakturę rozliczeniową -->
          <div class="tool-link flex items-center" *ngIf="canCreateSettlementInvoice"
            [routerLink]="'/konto/dokumenty/wystaw'" [queryParams]="{ settlementForAdvanceId: invoice?._id }">
            <mat-icon color="primary" svgIcon="tabler_outline:file-invoice"></mat-icon>
            Wystaw fakturę rozliczeniową
          </div>
          <div class="tool-link flex items-center" [routerLink]="'/konto/dokumenty/wystaw'"
            [queryParams]="{ similarDocumentId: invoice?._id }">
            <mat-icon color="primary" svgIcon="tabler_outline:copy"></mat-icon>
            Wystaw podobny dokument
          </div>
          <!-- Wystaw korektę -->
          <div *ngIf="canCreateCorrection" class="tool-link flex items-center" [routerLink]="'/konto/dokumenty/wystaw'"
            [queryParams]="{ toCorrectInvoiceId: invoice?._id }">
            <mat-icon color="primary" svgIcon="tabler_outline:file-minus"></mat-icon>
            Wystaw korektę
          </div>

          <br />

          <div class="tool-link flex items-center" [routerLink]="'/konto/dokumenty/' + invoice?._id"
            *ngIf="canEditDocument">
            <mat-icon color="primary" svgIcon="tabler_outline:pencil"></mat-icon>
            Edytuj
          </div>

          <!-- Powiązane faktury zaliczkowe (dla Zamówień i FakturaRozliczeniowa) -->
          <ng-container *ngIf="linkedAdvanceInvoices.length > 0">
            <div class="text-xs text-gray-500 dark:text-gray-400 mt-2 mb-1">
              {{ document?.documentType === 'FakturaRozliczeniowa' ? 'Powiązane faktury zaliczkowe:' : 'Powiązane
              zaliczki:' }}
            </div>
            <div *ngFor="let advInv of linkedAdvanceInvoices" class="tool-link flex items-center"
              [routerLink]="'/konto/dokumenty/' + advInv._id + '/podglad'">
              <mat-icon color="primary" svgIcon="tabler_outline:receipt"></mat-icon>
              {{ advInv.invoiceName || advInv.documentNumber }}
            </div>
            <!-- Komunikat "Edycja zablokowana" tylko dla Zamówień (nie dla FakturaRozliczeniowa) -->
            <div *ngIf="document?.documentType === 'Zamowienie'"
              class="text-xs text-gray-400 dark:text-gray-500 mt-1 flex items-center gap-1">
              <mat-icon class="!w-3 !h-3" svgIcon="tabler_outline:lock"></mat-icon>
              Edycja zablokowana
            </div>
          </ng-container>

          <!-- Powiązane zamówienie (dla faktur zaliczkowych) -->
          <ng-container *ngIf="linkedOrder">
            <div class="text-xs text-gray-500 dark:text-gray-400 mt-2 mb-1">Powiązane zamówienie:</div>
            <div class="tool-link flex items-center" [routerLink]="'/konto/dokumenty/' + linkedOrder._id + '/podglad'">
              <mat-icon color="primary" svgIcon="tabler_outline:file-text"></mat-icon>
              {{ linkedOrder.invoiceName || linkedOrder.documentNumber }}
            </div>
          </ng-container>

          <!-- Powiązana faktura rozliczeniowa (dla faktur zaliczkowych) -->
          <ng-container *ngIf="linkedSettlementInvoice">
            <div class="text-xs text-gray-500 dark:text-gray-400 mt-2 mb-1">Faktura rozliczeniowa:</div>
            <div class="tool-link flex items-center"
              [routerLink]="'/konto/dokumenty/' + linkedSettlementInvoice._id + '/podglad'">
              <mat-icon color="primary" svgIcon="tabler_outline:file-check"></mat-icon>
              {{ linkedSettlementInvoice.invoiceName || linkedSettlementInvoice.documentNumber }}
            </div>
          </ng-container>

          <!-- Korygowany dokument (dla faktur korygujących) -->
          <ng-container *ngIf="correctedDocument">
            <div class="text-xs text-gray-500 dark:text-gray-400 mt-2 mb-1">Korygowany dokument:</div>
            <div class="tool-link flex items-center"
              [routerLink]="'/konto/dokumenty/' + correctedDocument._id + '/podglad'">
              <mat-icon color="primary" svgIcon="tabler_outline:file-minus"></mat-icon>
              {{ correctedDocument.invoiceName || correctedDocument.documentNumber }}
            </div>
          </ng-container>

          <!-- Korekty tego dokumentu -->
          <ng-container *ngIf="correctionDocuments.length > 0">
            <div class="text-xs text-gray-500 dark:text-gray-400 mt-2 mb-1">Korekty:</div>
            <div *ngFor="let corrDoc of correctionDocuments" class="tool-link flex items-center"
              [routerLink]="'/konto/dokumenty/' + corrDoc._id + '/podglad'">
              <mat-icon color="primary" svgIcon="tabler_outline:file-diff"></mat-icon>
              {{ corrDoc.invoiceName || corrDoc.documentNumber }}
            </div>
            <div class="text-xs text-gray-400 dark:text-gray-500 mt-1 flex items-center gap-1">
              <mat-icon class="!w-3 !h-3" svgIcon="tabler_outline:lock"></mat-icon>
              Edycja zablokowana (dokument skorygowany)
            </div>
          </ng-container>

          <div class="tool-link flex items-center" *ngIf="canChangeToDraft" (click)="markAsPaidOrTemplate(false)">
            <mat-icon color="primary" svgIcon="tabler_outline:hammer"></mat-icon>
            Zmień na szkic
          </div>

          <!-- <br/> -->
          <!-- <div class="tool-link" [routerLink]="'/konto/dokumenty/' + invoice?._id"><i class="ti ti-corner-up-right"></i>Wyślij fakturę emailem</div> -->

          <br />

          <div class="tool-link flex items-center" (click)="showSendEmailDialog()">
            <mat-icon color="primary" svgIcon="tabler_outline:mail-share"></mat-icon>
            Wyślij przez e-mail
          </div>

          <div class="tool-link flex items-center" (click)="download()">
            <mat-icon color="primary" svgIcon="tabler_outline:download"></mat-icon>
            Pobierz PDF
          </div>
          <div class="tool-link flex items-center" *ngIf="document?.ksefUpo" (click)="downloadUpo()">
            <mat-icon color="primary" svgIcon="tabler_outline:certificate"></mat-icon>
            Pobierz UPO
          </div>
          <div class="tool-link flex items-center" (click)="print()">
            <mat-icon color="primary" svgIcon="tabler_outline:printer"></mat-icon>
            Drukuj
          </div>

          <br />

          <div *ngIf="canDeleteDocument" class="tool-link flex items-center delete-action"
            (click)="confirmDeleteInvoice()">
            <mat-icon color="warn" class="delete-action" svgIcon="tabler_outline:trash"></mat-icon>
            Usuń
          </div>
        </ng-container>
        <!-- === KONIEC NARZĘDZI DLA LOKALNYCH FAKTUR === -->

      </div>
    </div>
  </div>

  <div class="row mt-5" *ngIf="document?.direction !== 'expense' && !isKsefDocument">
    <div class="col-lg-8">
      <div class="rounded-xl p-5 max-w-200" data-tour-id="historia-aktywnosci">
        Aktywność
        <div class="text-3xl flex items-center">Historia dokumentu</div>
        <div *ngIf="activityLogs.length == 0" class="my-8 text-secondary">
          Brak danych do wyświetlenia
        </div>

        <!-- Widoczne logi aktywności -->
        <activity-logs *ngIf="activityLogs.length > 0" [activityLogs]="visibleActivityLogs"></activity-logs>

        <!-- PRO Feature - Blur Overlay dla ukrytych logów -->
        <div *ngIf="!isFullHistoryAvailable && hiddenLogsCount > 0" class="relative mt-4 mb-[50px]">

          <!-- Ikona kłódki - wystawająca poza kontener -->
          <div
            class="absolute -top-3 -left-3 z-20 w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500 via-primary-500 to-blue-500 flex items-center justify-center shadow-lg shadow-primary-500/40">
            <mat-icon [svgIcon]="'tabler_outline:lock'" class="!w-6 !h-6 text-white"></mat-icon>
          </div>

          <!-- Kontener z blurowanym tłem -->
          <div class="relative rounded-2xl overflow-hidden bg-gray-200 dark:bg-gray-800/50 min-h-[320px]">

            <!-- Fake blurred logs - timeline skeleton -->
            <div class="blur-[3px] opacity-70 pointer-events-none select-none p-5">
              <div class="relative pl-12">
                <!-- Linia pionowa timeline -->
                <div class="absolute left-[11px] top-3 bottom-3 w-0.5 bg-gray-400 dark:bg-gray-600"></div>

                <div class="space-y-6">
                  <!-- Log 1 - z rozbudowanymi zmianami -->
                  <div class="relative">
                    <!-- Marker - większy -->
                    <div
                      class="absolute -left-12 w-6 h-6 rounded-full bg-gray-400 dark:bg-gray-500 border-2 border-gray-200 dark:border-gray-800 flex items-center justify-center">
                      <div class="w-2.5 h-2.5 bg-gray-300 dark:bg-gray-600 rounded-sm"></div>
                    </div>
                    <!-- Content -->
                    <div class="space-y-1.5">
                      <div class="flex items-center justify-between">
                        <div class="h-4 w-28 bg-gray-400 dark:bg-gray-500 rounded"></div>
                        <div class="h-3 w-32 bg-gray-300 dark:bg-gray-600 rounded"></div>
                      </div>
                      <!-- Zmiany -->
                      <div class="mt-2 p-3 rounded-lg bg-gray-300/50 dark:bg-gray-700/50 space-y-2">
                        <div class="flex items-center gap-2">
                          <div class="h-3 w-20 bg-gray-400 dark:bg-gray-500 rounded"></div>
                          <div class="h-3 w-16 bg-gray-300 dark:bg-gray-600 rounded"></div>
                          <div class="h-3 w-6 bg-gray-300 dark:bg-gray-600 rounded"></div>
                          <div class="h-3 w-20 bg-gray-300 dark:bg-gray-600 rounded"></div>
                        </div>
                        <div class="flex items-center gap-2">
                          <div class="h-3 w-24 bg-gray-400 dark:bg-gray-500 rounded"></div>
                          <div class="h-3 w-12 bg-gray-300 dark:bg-gray-600 rounded"></div>
                          <div class="h-3 w-6 bg-gray-300 dark:bg-gray-600 rounded"></div>
                          <div class="h-3 w-14 bg-gray-300 dark:bg-gray-600 rounded"></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Log 2 - prosty -->
                  <div class="relative">
                    <div
                      class="absolute -left-12 w-6 h-6 rounded-full bg-gray-400 dark:bg-gray-500 border-2 border-gray-200 dark:border-gray-800 flex items-center justify-center">
                      <div class="w-2.5 h-2.5 bg-gray-300 dark:bg-gray-600 rounded-sm"></div>
                    </div>
                    <div class="space-y-1.5">
                      <div class="flex items-center justify-between">
                        <div class="h-4 w-36 bg-gray-400 dark:bg-gray-500 rounded"></div>
                        <div class="h-3 w-28 bg-gray-300 dark:bg-gray-600 rounded"></div>
                      </div>
                    </div>
                  </div>

                  <!-- Log 3 - z jedną zmianą -->
                  <div class="relative">
                    <div
                      class="absolute -left-12 w-6 h-6 rounded-full bg-gray-400 dark:bg-gray-500 border-2 border-gray-200 dark:border-gray-800 flex items-center justify-center">
                      <div class="w-2.5 h-2.5 bg-gray-300 dark:bg-gray-600 rounded-sm"></div>
                    </div>
                    <div class="space-y-1.5">
                      <div class="flex items-center justify-between">
                        <div class="h-4 w-24 bg-gray-400 dark:bg-gray-500 rounded"></div>
                        <div class="h-3 w-28 bg-gray-300 dark:bg-gray-600 rounded"></div>
                      </div>
                      <div class="mt-2 p-3 rounded-lg bg-gray-300/50 dark:bg-gray-700/50">
                        <div class="flex items-center gap-2">
                          <div class="h-3 w-16 bg-gray-400 dark:bg-gray-500 rounded"></div>
                          <div class="h-3 w-24 bg-gray-300 dark:bg-gray-600 rounded"></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Log 4 - prosty -->
                  <div class="relative">
                    <div
                      class="absolute -left-12 w-6 h-6 rounded-full bg-gray-400 dark:bg-gray-500 border-2 border-gray-200 dark:border-gray-800 flex items-center justify-center">
                      <div class="w-2.5 h-2.5 bg-gray-300 dark:bg-gray-600 rounded-sm"></div>
                    </div>
                    <div class="space-y-1.5">
                      <div class="flex items-center justify-between">
                        <div class="h-4 w-32 bg-gray-400 dark:bg-gray-500 rounded"></div>
                        <div class="h-3 w-24 bg-gray-300 dark:bg-gray-600 rounded"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Overlay card z zachętą do PRO -->
            <div
              class="absolute inset-0 flex items-center justify-center bg-gradient-to-t from-gray-200/95 via-gray-200/70 to-gray-200/95 dark:from-gray-900/95 dark:via-gray-900/70 dark:to-gray-900/95">
              <div
                class="relative overflow-hidden rounded-2xl bg-white dark:bg-gradient-to-br dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 p-6 mx-4 shadow-xl dark:shadow-2xl border border-gray-200 dark:border-gray-700/50 max-w-sm w-full">

                <!-- Dekoracja tła -->
                <div
                  class="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-purple-500/10 dark:from-purple-500/30 to-primary-500/10 dark:to-primary-500/30 rounded-full blur-2xl">
                </div>
                <div
                  class="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-blue-500/10 dark:from-amber-500/30 to-cyan-500/10 dark:to-orange-500/30 rounded-full blur-2xl">
                </div>

                <div class="relative z-10 text-center">

                  <!-- Licznik ukrytych zmian - fioletowy badge -->
                  <div
                    class="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-purple-100 dark:bg-purple-500/20 text-purple-600 dark:text-purple-400 text-sm font-semibold mb-4">
                    <mat-icon [svgIcon]="'tabler_outline:history'" class="!w-4 !h-4"></mat-icon>
                    <span>{{ hiddenLogsCount }} {{ hiddenLogsCount === 1 ? 'zmiana do odkrycia' : (hiddenLogsCount < 5
                        ? 'zmiany do odkrycia' : 'zmian do odkrycia' ) }}</span>
                  </div>

                  <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-2">
                    Pełna historia zmian
                  </h3>

                  <p class="text-gray-600 dark:text-gray-400 text-sm mb-5 leading-relaxed">
                    Śledź każdą edycję, pobranie, wydruk i wysyłkę dokumentu.
                    <span class="text-primary-600 dark:text-amber-400 font-semibold">Dostępne w planie PRO.</span>
                  </p>

                  <!-- CTA Button -->
                  <a routerLink="/konto/subskrypcje" class="group relative inline-flex items-center justify-center w-full h-12 text-sm font-bold text-white transition-all duration-300 rounded-xl overflow-hidden
                         bg-gradient-to-r from-purple-500 via-primary-500 to-blue-500
                         hover:from-purple-400 hover:via-primary-400 hover:to-blue-400
                         shadow-lg shadow-primary-500/25 hover:shadow-xl hover:shadow-primary-500/40
                         hover:scale-[1.02] active:scale-100">
                    <span class="relative z-10 flex items-center gap-2">
                      <mat-icon [svgIcon]="'tabler_outline:crown'" class="!w-5 !h-5 text-white"></mat-icon>
                      <span>Odblokuj w planie PRO</span>
                      <mat-icon [svgIcon]="'tabler_outline:arrow-right'"
                        class="!w-4 !h-4 text-white transition-transform group-hover:translate-x-1"></mat-icon>
                    </span>
                    <div
                      class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700">
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>